package com.schoolconnect.app.feature.schoolstaff

import androidx.compose.runtime.Composable
import com.schoolconnect.app.feature.staff.StaffFeatureRoute

/** Compatibility entry point that reuses the production staff-management flow. */
@Composable
fun SchoolStaffFeatureRoute(
    onBack: () -> Unit,
    schoolId: String = "",
    shellRoleCode: String = "",
    shellSchoolLabel: String = "iConnect.School",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    StaffFeatureRoute(
        onBack = onBack,
        schoolId = schoolId,
        shellRoleCode = shellRoleCode,
        shellSchoolLabel = shellSchoolLabel,
        onChangeRole = onChangeRole,
        onLogout = onLogout
    )
}
